import { ResponseError } from '../../errors/ResponseError';
import { IApplicationContext } from '../../types/applicationContext';
import { TGetRecommendationsWebRequest, TRecommendationsResult } from './types';

type TRecommendationsPageResponse = TRecommendationsResult & {
  errors?: object;
  message?: string;
};

const DEGRADATION_TELEMETRY_KEY = 'degradation.recommendations.pagination';
const RECOMMENDATIONS_PAGE_API_PATH = '/recommendations/api/v1/get-recommendations';

export async function fetchRecommendationsPage(
  context: IApplicationContext,
  parameters: TGetRecommendationsWebRequest,
): Promise<TRecommendationsResult> {
  const { logger, telemetry } = context;

  try {
    const response = await fetch(RECOMMENDATIONS_PAGE_API_PATH, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(parameters),
    });
    const responseBody = (await response.json()) as TRecommendationsPageResponse;

    if (!response.ok) {
      throw new ResponseError({
        domain: 'fetchRecommendationsPage',
        message: responseBody.message || 'Не удалось получить список рекомендаций',
        details: { errors: JSON.stringify(responseBody.errors) },
      });
    }

    return responseBody;
  } catch (error) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.warning(error, {
      domain: 'fetchRecommendationsPage',
      message: 'Не удалось получить следующую страницу рекомендаций',
    });

    throw error;
  }
}
